import type {CssPropertyEnumCssPropertyType} from '@wix/ambassador-devcenter-v1-component-type-data/types'
import {CSS_PROPERTIES} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import

interface CSSVariableData {
    type: string
    value: string | number
}

const isVariableData = (value: unknown): value is CSSVariableData => {
    return typeof value === 'object' && value !== null && 'type' in value && 'value' in value
}

const normalizeVariableLengthValue = (value: CSSVariableData): string => {
    return value.type === 'percentage' ? `${value.value}%` : `${value.value}${value.type}`
}

// temporarily mapping, while we don't have a full mapping
export const convertDMVariableToCSSValue = (cssPropertyType: CssPropertyEnumCssPropertyType, value: unknown) => {
    if (!cssPropertyType || !isVariableData(value)) {
        return value
    }

    switch (cssPropertyType) {
        case CSS_PROPERTIES.CSS_PROPERTY_TYPE.length:
            return normalizeVariableLengthValue(value)
        case CSS_PROPERTIES.CSS_PROPERTY_TYPE.number:
            return value.value.toString()
        case CSS_PROPERTIES.CSS_PROPERTY_TYPE.percentage:
            return `${value.value}%`
        default:
            return value.value
    }
}
